import { Alert } from './../../../../shared/alerts/simple-message/simple-message.component';
import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AssociationsService } from 'app/services/associations.service';
import { AssociationHelper } from 'app/storage/association.storage';
import { MeetingFormService } from '../../meeting-form.service';
import { Fields } from './components/tick-box.component';
import { collectFieldErrors, FieldError, focusAndScrollToField } from 'app/shared/forms/form-validation.util';

@Component({
  selector: 'form-composer',
  templateUrl: './form-composer.component.html',
  styleUrls: ['../../meeting-form.component.scss', '../form-steps.scss', './form-composer.component.scss']
})
export class FormComposerComponent implements OnInit {

  @Input() form_structure_name: string = ""


  showAlert: boolean = false
  alertMessage: string = ''
  alertType: Alert = Alert.SUCCESS

  fields: Fields = {
    'Question 1': ['A', 'B', 'C'],
    'Question 2': ['A', 'B', 'C', 'E', 'F'],
    'Question 3': ['A', 'B', 'C', 'E']
  }

  /*questions: Question[] = [
    {
      "Question 1": "open"
    },
    {
      "Question 2": ['A', 'B', 'C', 'E', 'F']
    },
    {
      "Quesiton 3": "editor"
    }
  ]*/

  questions: Question[];
  title: string; 

  MEETING_FORM = 0

  submitted: boolean = false
  fieldErrors: FieldError[] = []

  constructor(
    private mongoService: AssociationsService,
    private helper: AssociationHelper,
    private service: MeetingFormService,
    private router: Router,
    private hostRef: ElementRef,
  ) {
    let meeting = this.helper.getMeetingForm()
    if(meeting <= 0){
      meeting = 1
    }
    try{
      let data = require(`assets/meeting-form/advice.json`)
      this.questions = data['questions']
      this.title = data['title']
      this.MEETING_FORM = meeting
    } catch (e){
      this.questions = []
      this.title = ''
    }
  
   }

  ngOnInit(): void {
    
  }

  isOpenQuestion(question: Question) {

    return typeof question[this.getQuestionKey(question)] === 'string'

  }

  getQuestionKey(question: Question): string{
    return Object.keys(question)[0]
  }

  getQuestion(question: Question): string[] | string{
    return Object.values(question)[0]
  }

  confirm(): void{
    this.submitted = true
    const form = this.service.getForm()
    const fields: FieldError[] = Object.keys(form.controls).map(key => ({ key, label: key }))
    this.fieldErrors = collectFieldErrors(form, fields)
    if(this.fieldErrors.length){
      focusAndScrollToField(this.hostRef.nativeElement, this.fieldErrors[0].key)
      return
    }

    let meeting = this.helper.getMeetingForm()
    if(meeting <= 0)
      meeting = 1

    let nextStep = this.service.getNextStep(meeting)
    let complete = false
    if(nextStep == 'first')
      complete = true
    this.mongoService.submitForm(
        this.helper.getSelectedProject(),
        this.helper.getSelectedEpe(),
        this.service.getSubmitMeetingValue(meeting),
        this.service.getSubmit(),
        complete,
        false
        ).subscribe(
          () => {
            if(complete)
              meeting++
            this.helper.setMeetingForm(meeting)
            // PSS has no final meeting: after the advice go straight to the closure step
            if(meeting == 5 && this.helper.isPss())
              nextStep = 'third'
            this.router.navigateByUrl(`form/(meeting-form:meeting_${meeting}/(meeting_${meeting}:${nextStep}))`)
          }
        )
  }

  addAlert(message: string, type: Alert){

    this.alertMessage = message
    this.alertType = type
    this.showAlert = true

  }

  jumpToField(key: string): void {
    focusAndScrollToField(this.hostRef.nativeElement, key)
  }

}

export interface Question {
  [key:string]: string[] | string
}
